export const COOKIE_NAME = 'storevio_cart_id';
export const CUSTOMER_COOKIE = 'storevio_customer_token'

